import NoticesLoader from './NoticesLoader'
export default NoticesLoader;


// WEBPACK FOOTER //
// ./src/components/App/NoticesLoader/index.js